module.exports = __webpack_public_path__ + "static/media/logo.fa00af7b.png";